import { AlertCircle } from 'lucide-react';

interface RenewalExpiredAlertProps {
  renewalDate: string;
}

export function RenewalExpiredAlert({ renewalDate }: RenewalExpiredAlertProps) {
  const formattedDate = new Date(renewalDate).toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });

  const whatsappMessage = encodeURIComponent('Olá Saulo, gostaria de renovar meu plano de gestão');
  const whatsappUrl = `https://wa.me/5513978240168?text=${whatsappMessage}`;

  return (
    <>
      {/* Overlay de fundo - desfoca o conteúdo */}
      <div className="fixed inset-0 z-40 bg-background/80 backdrop-blur-sm" />

      {/* Modal de alerta */}
      <div className="fixed inset-0 z-[45] flex items-center justify-center p-4">
        <div className="w-full max-w-md bg-card border-2 border-red-500 rounded-xl shadow-2xl p-6 space-y-4">
          {/* Ícone de alerta */}
          <div className="flex justify-center">
            <div className="p-4 bg-red-100 dark:bg-red-900/30 rounded-full">
              <AlertCircle className="h-12 w-12 text-red-600 dark:text-red-400" />
            </div>
          </div>

          {/* Título */}
          <div className="text-center">
            <h2 className="text-2xl font-bold text-foreground mb-2">
              Período de Renovação Vencido
            </h2>
            <p className="text-muted-foreground">
              Sua data de renovação era{' '}
              <span className="font-semibold text-red-600 dark:text-red-400">
                {formattedDate}
              </span>
            </p>
          </div>

          {/* Mensagem principal */}
          <div className="bg-red-50 dark:bg-red-950/20 border border-red-200 dark:border-red-800 rounded-lg p-4">
            <p className="text-sm text-foreground/90 leading-relaxed">
              O período de renovação do seu plano já passou. Para continuar aproveitando nossos
              serviços e ter acesso completo à plataforma, entre em contato com nossa equipe para
              renovar seu plano.
            </p>
          </div>

          {/* Botão de ação */}
          <div className="pt-2">
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full block text-center px-6 py-3 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-lg transition-colors"
            >
              Renovar Plano
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
